export default {    
    form: {        
        fields: {            
            condicao: {
                fields: {
                    firstField: {
                        label: "Campo",
                        description: "Cuál será el campo a validar."
                    },
                    rule: {
                        label: "Condición",
                        description: "Cuál será la condición."
                    },
                    secondField: {
                        label: "Valor",
                        description: "Cuál será el valor a comparar."
                    },
                    thirdField: {
                        label: "Otra Cantidad",
                        description: "Cuál será el otro valor a comparar."
                    },
                    fourthField: {
                        label: "Resultado",
                        description: "Cuál será el valor del resultado."
                    }                    
                },
                DB_fields: {                    
                    value_quantity_value: "Valor del resultado"
                },
                rules: {
                    isNull: "Está vacío",
                    isNotNull: "No esta vacio",
                    bigger: "Más grande que",
                    biggerOrEqual: "Mayor qué o igual a",
                    less: "Menos que",
                    lessOrEqual: "Menos que o igual a",
                    equal: "es igual a",
                    different: "es otro que",
                    between: "Es entre",
                    notBetween: "No está entre"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Añadir Condición',
            remover_condicao: 'Quitar condición',
            salvar: 'Guardar Condición'
        },
        create: {
            success: "¡Condición creada con éxito!",
            error: "¡Error al crear la condición!"
        },
        update: {
            success: "¡Condición editada con éxito!",
            error: "¡Condición de edición de error!"
        }
    }
}
